import ReelerIconV2 from "./ReelerIconV2"

export default ReelerIconV2
